import api from "./apiConfig";

export const SEND_INCIDENT_EMAIL = async (data) => {
    try {
        const response = await api.post("/sendIncidentEmail", data);
        return response.data;
    } catch (error) {
        console.error("Error al enviar email:", error);
        throw error;
    }
};